module.exports = "<div class=\"tab-menu js-tab-menu js-gallery-menu\" >\r\n    <% categories.forEach(function(item, index) { %>\r\n        <div class=\"tab-menu__item\">\r\n            <button type=\"button\"\r\n                    class=\"tab-menu__link js-tab-menu-link <%-index === 0 ? 'active' : '' %>\"\r\n                    data-category=\"<%-item.code%>\">\r\n                <%-item.value%>\r\n            </button>\r\n        </div>\r\n    <% })  %>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./js/components/Gallery/GalleryMenu.ejs
// module id = 230
// module chunks = 0